<template>
	<th v-if="isHeader">
		<!--  -->
		Actions
	</th>
	<td v-else>
		<div>
			<dropdown v-if="$route.meta.isAdmin">
				<dropdown-action
					success
					icon="edit"
					@click="onClickEdit"
					v-if="userCanEdit"
					>Edit document</dropdown-action
				>
				<dropdown-action
					success
					icon="tick"
					@click="onClickApprove"
					v-if="
						rowData.current_version &&
							rowData.current_version.status === 'pending' &&
							userCanApprove
					"
					>Approve document</dropdown-action
				>

				<dropdown-action
					danger
					icon="cross"
					@click="onClickReject"
					v-if="
						rowData.current_version &&
							rowData.current_version.status === 'pending' &&
							userCanApprove
					"
					>Reject document</dropdown-action
				>

				<dropdown-action
					danger
					icon="back"
					@click="onClickReinstate"
					v-if="
						!rowData.current_version &&
							rowData.current_version.status !== 'rejected' &&
							userCanEdit
					"
					>Re-instate version</dropdown-action
				>

				<!-- <dropdown-action icon="chart" @click="onClickDownloadInsights">Download Insights</dropdown-action> -->
				<dropdown-action icon="preview" @click="onClickPreview"
					>Preview document</dropdown-action
				>
				<dropdown-action
					icon="delete"
					@click="onClickDelete"
					v-if="userCanDelete && rowData.status !== 'rejected'"
					>Delete document</dropdown-action
				>
				<dropdown-action
					icon="edit"
					@click="onClickCreateVersion"
					v-if="userCanEdit && rowData.current_version.status === 'approved'"
					>Create new version</dropdown-action
				>
				<dropdown-action
					icon="archive"
					@click="onClickArchive"
					v-if="userCanEdit && rowData.current_version.status === 'approved'"
					>Archive</dropdown-action
				>
			</dropdown>

			<div v-else>
				<ul class="listless inline">
					<li>
						<base-tooltip
							:text="
								rowData.user_favourite
									? 'Remove from Starred'
									: 'Add to Starred'
							"
						>
							<tr-action
								icon="star"
								label="Star"
								@click="onClickStar"
								:active="rowData.user_favourite"
							></tr-action>
						</base-tooltip>
					</li>
					<li>
						<base-tooltip text="Download">
							<tr-action
								icon="download"
								label="Download"
								@click="onClickDownload"
							></tr-action>
						</base-tooltip>
					</li>
					<li>
						<base-tooltip text="Create new Version">
							<tr-action
								icon="edit"
								label="Create new Version"
								@click="onClickCreateVersion"
								v-if="!rowData.policy_id && userCanEdit"
							></tr-action>
						</base-tooltip>
					</li>
				</ul>
			</div>
		</div>
	</td>
</template>

<script>
import Dropdown from './Dropdown'
import DropdownAction from './DropdownAction'
import { Download } from './../mixins/download'

import TrAction from './TableRowAction'

import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import UserHasPermission from '@/mixins/UserHasPermission'

export default {
	name: 'document-actions',

	props: {
		rowData: Object,
	},

	data() {
		return {
			docType: null,
		}
	},

	computed: {
		/**
		 * Permission stuff
		 */
		userCanEdit() {
			return this.userHasPermission(`add_${this.docType}`)
		},

		userCanApprove() {
			return this.userHasPermission(`approve_${this.docType}`)
		},

		userCanDelete() {
			return this.userHasPermission(`delete_${this.docType}`)
		},
	},

	methods: {
		onClickCreateVersion() {
			if (this.rowData.policy_id) {
				this.$router.push({
					name: 'AdminDocumentCreateVersion',
					params: { id: this.rowData.policy_id },
				})
			} else {
				this.$router.push({
					name: 'AdminDocumentCreateVersion',
					params: { id: this.rowData.id },
				})
			}
		},

		onClickArchive() {
			this.$router.push({
				name: 'AdminDocumentArchive',
				params: { id: this.rowData.id },
			})
		},

		onClickDownload() {
			const vm = this
			const fileData = vm.rowData.current_version.file
			this.$store.dispatch('files/download', fileData)
			this.showWarning()
		},

		onClickApprove() {
			if (this.rowData.policy_id) {
				this.$router.push({
					name: 'AdminDocumentVersionApprove',
					params: { id: this.rowData.policy_id, versionId: this.rowData.id },
				})
			} else if (this.rowData.form_id) {
				this.$router.push({
					name: 'AdminDocumentVersionApprove',
					params: { id: this.rowData.form_id, versionId: this.rowData.id },
				})
			} else {
				this.$router.push({
					name: 'AdminDocumentApprove',
					params: { id: this.rowData.id },
				})
			}
		},

		onClickEdit() {
			if (this.rowData.policy_id) {
				this.$router.push({
					name: 'AdminDocumentVersionEdit',
					params: { id: this.rowData.policy_id, versionId: this.rowData.id },
				})
			} else if (this.rowData.form_id) {
				this.$router.push({
					name: 'AdminDocumentVersionEdit',
					params: { id: this.rowData.form_id, versionId: this.rowData.id },
				})
			} else {
				this.$router.push({
					name: 'AdminDocumentEdit',
					params: { id: this.rowData.id },
				})
			}
		},

		onClickReject() {
			if (this.rowData.policy_id) {
				this.$router.push({
					name: 'AdminDocumentVersionReject',
					params: { id: this.rowData.policy_id, versionId: this.rowData.id },
				})
			} else if (this.rowData.form_id) {
				this.$router.push({
					name: 'AdminDocumentVersionReject',
					params: { id: this.rowData.form_id, versionId: this.rowData.id },
				})
			} else {
				this.$router.push({
					name: 'AdminDocumentReject',
					params: { id: this.rowData.id },
				})
			}
		},

		onClickDownloadInsights() {
			// TODO:
		},

		onClickPreview() {
			if (this.rowData.policy_id) {
				this.$router.push({
					name: 'AdminDocumentVersionPreview',
					params: { id: this.rowData.policy_id, versionId: this.rowData.id },
				})
			} else if (this.rowData.form_id) {
				this.$router.push({
					name: 'AdminDocumentVersionPreview',
					params: { id: this.rowData.form_id, versionId: this.rowData.id },
				})
			} else {
				this.$router.push({
					name: 'AdminDocumentPreview',
					params: { id: this.rowData.id },
				})
			}
		},

		onClickStar() {
			if (!this.rowData.user_favourite) {
				this.$store.dispatch('documents/favourite', this.rowData.id)
			} else {
				this.$store.dispatch('documents/unfavourite', this.rowData.id)
			}

			this.rowData.user_favourite = !this.rowData.user_favourite
		},

		onClickDelete() {
			this.$store.dispatch('createDialog', {
				confirm: () => {
					this.$store.dispatch('documents/delete', this.rowData.id)
				},
			})
		},

		onClickReinstate() {
			this.$store.dispatch('createDialog', {
				// TODO: This does the right thing, but do we need to create its own
				// method in the store so we can alter the confirmation etc.?
				confirm: () => {
					this.$store
						.dispatch('documents/approveDocument', {
							documentId: this.rowData.policy_id,
							versionId: this.rowData.id,
						})
						.then((resp) => {
							this.$store.dispatch('documents/list')
						})
				},
			})
		},
	},

	components: {
		Dropdown,
		DropdownAction,
		TrAction,
	},

	created() {
		this.docType = this.$store.state.documents.docType.plural
	},

	mixins: [VuetableFieldMixin, Download, UserHasPermission],
}
</script>
